exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feedbackOverrideDisplay{display:inline-block;line-height:1;margin-top:20px}.feedbackOverrideDisplay img{margin-left:5px}.feedbackOverrideDisplay .overrideStar{position:relative;font-weight:700;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/feedback_override_display.scss
// module id = 1442
// module chunks = 0